import React from 'react';
import { SvgIcon } from '@mui/material';
import { COLORS } from 'pvs-design-system';

// Custom unchecked icon with beige background for disabled checkboxes
const UncheckedIcon = () => (
  <SvgIcon viewBox="0 0 24 24">
    <rect
      x="2.66675"
      y="2.66663"
      width="18.6667"
      height="18.6667"
      fill={COLORS.beige[400]}
    />
    <path
      d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      fill={COLORS.gray[400]}
    />
  </SvgIcon>
);

export default UncheckedIcon;
